import React from 'react';
import { FacebookProvider, Comments, Initialize } from 'react-facebook';
import { LoadingSpinner } from '../../components/LoadingSpinner';

import "./style.sass";

const GreetingByFBComments = () => {
    const commentLocation = window.location.search 
        ? window.location.href.substring(0, window.location.href.indexOf("?"))
        : window.location.href

    return (
        <>
            <section className='hero is-bold has-background-golden'>
                <div className='hero-body'>
                    <div className="pt-2 pb-4">
                        <h1 className='py-4 pb-6 has-text-centered section'>
                            <p className='title is-size-3 py-2' style={{ letterSpacing: "0.1em" }}>
                                Let's greet together
                            </p>
                        </h1>
                        <FacebookProvider appId="3566132340072905">
                        <Initialize>
                            {({ isReady }) => {
                                return isReady 
                                    ? <Comments href={commentLocation} width="100%" /> 
                                    : <LoadingSpinner message="Loading..." loaderColor='#00d1b2' loaderType='ThreeDots' />;
                            }}
                        </Initialize>
                            
                        </FacebookProvider>
                    </div>
                </div>
            </section>
        </>
    )
}

export default GreetingByFBComments;
